import React from 'react';
import { matchPath, useHistory } from 'react-router';
import {
  Avatar,
  Box,
  Container,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@material-ui/core';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import Page from '../../components/Layout/Page';
import Logo from '../../components/Layout/Logo';
import SetPasswordForm from './SetPasswordForm';

import useStyles from './styles';

function VerificationView() {
  const classes = useStyles();
  const history = useHistory();

  const handleSubmitSuccess = () => {
    history.push('/login');
  };

  const match = matchPath(window.location.pathname, {
    path: '/verificacion-usuario/:token',
    exact: true,
    strict: false,
  });

  const { token } = match.params;

  return (
    <Page
      className={classes.root}
      title="Verificacion Usuario"
    >
      <Container maxWidth="md">
        <Box
          mb={8}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Logo imgUrl="/img/logos/logo_color.svg" className={classes.logo} />
        </Box>
        <Card className={classes.card} >
          <CardContent className={classes.content}>
            <Avatar className={classes.icon}>
              <AccountBoxIcon fontSize="large" />
            </Avatar>
            <Typography
              variant="h2"
              color='primary'
            >
              Verifica tu cuenta
            </Typography>
            <Typography
              variant="subtitle1"
              color="textSecondary"
            >
              Ingresa tu nueva contraseña
            </Typography>
            <Box mt={3}>
              <SetPasswordForm onSubmitSuccess={handleSubmitSuccess} token={token} />
            </Box>
            <Box my={2}>
              <Divider />
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default VerificationView;
